import { CouncilDashboard } from "@/components/CouncilDashboard"

export default function CouncilDashboardPage() {
  return <CouncilDashboard />
}
